<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-title-praise"><span>Praise for the Writing of Michael Swanwick</span></p>
<p class="chap-sub-pc"><span>The Iron Dragon’s Daughter</span></p>
<p class="chap-pc"><span>A New York Times Notable Book</span></p>
<p class="praise-n">“Eerie … extraordinary … Dickens meets Detroit, full of grimy, toiling waifs, dark factories, trolls with boomboxes, and sleek, decadent high elves … Sordid, violent, funny, absurd, angry, by turns, as intense in its pleasures as in its pains … Swanwick takes huge risks here, and reaps big rewards.” —<i>Locus</i> </p>
<p class="praise-n">“Entertaining reading … Flamboyant … Grotesquely Dickensian.” —<i>Newsday</i></p>
<p class="chap-sub-pc"><span>In the Drift</span></p>
<p class="praise-n">“This episodic tale of life, war and survival in post-meltdown Pennsylvania builds a potent new myth from the reality of radioactive waste.” —George R. R. Martin</p>
<p class="praise-n">“Shocking … powerful.” —<i>Daily News</i> (New York)</p>
<p class="praise-n">“A powerful and affecting novel … Chilling, believable and uncomfortably close to home.” —<i>The Evening Sun</i> (Baltimore)</p>
<p class="chap-sub-pc"><span>Bones of the Earth</span></p>
<p class="praise-n">“<i>Jurassic Park</i> set amid the paradox of time travel … I dare anyone to read the first chapter and not keep reading all the way through to the last shocking page.” —James Rollins, <i>New York Times–</i>bestselling author of <i>Subterranean</i> and <i>Bone Labyrinth</i></p>
<p class="praise-n">“Swanwick dramatizes of the world of dinosaurs with great flair and knowledge, even love. <i>Bones of the Earth</i> dances on the edge of an abyss.… [An] entertaining and deft performance.” —<i>The Philadelphia Inquirer</i></p>
<p class="praise-n">“Swanwick proves that sci-fi has plenty of room for wonder and literary values.” —<i>San Francisco Chronicle</i></p>
<p class="chap-sub-pc"><span>Jack Faust</span></p>
<p class="praise-n">“<i>Jack Faust</i> is madly ambitious and brilliantly executed, recasting the entire history of science in a wholly original version of our culture’s central myth of knowledge, power, and sorrow.” —William Gibson</p>
<p class="praise-n">“Superb … Wonderful and relentless … Provocative and evocative.” —<i>The Washington Post Book World</i></p>
<p class="praise-n">“Powerful … Marvelous … Consistently surprising.” —<i>The</i> <i>New York Times Book Review</i></p>
<p class="chap-sub-pc"><span>Vacuum Flowers</span></p>
<p class="praise-n">“Slick and highly competent entertainment that starts fast and never slows down.” —<i>The Washington Post</i> </p>
<p class="praise-n">“Erotic and witty.” —<i>The New York Times</i> </p>
<p class="praise-n">“Quintessentially cyberpunk … eminently readable and provocative.” —<i>Daily News</i> (New York)</p>
<p class="chap-sub-pc"><span>Tales of Old Earth</span></p>
<p class="praise-n">“A stunning collection from one of science fiction’s very best writers. Pay in blood, if necessary, but don’t miss these stories.” —Nancy Kress</p>
<p class="praise-n">“Michael Swanwick is darkly magnificent. <i>Tales of Old Earth</i> is just one brilliant ride after another, a midnight express with a master at the throttle.” —Jack McDevitt</p>
<p class="praise-n">“Swanwick has emerged as one of the country’s most respected authors.” —<i>The Philadelphia Inquirer</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// praise.vue?3ba2e3fe